import React, { useCallback } from 'react'
import '../ConfigTable.css'
import './ProgKeyLabel.css'

export default function ProgKeyLabel({keyName, setEditMode, isLocked, isJustCreated}) {   
  const handleClick = useCallback((e) => {
    setEditMode();
  }, [setEditMode]);
  
  return (
    <div className={`progKeyLabel ${isLocked ? 'progKeyLocked':'progKeyEditable'} ${isJustCreated ? 'justCreated' : ''}`} onClick={handleClick}>
      {keyName}
    </div>
  )
}
